/* ============ Olyndra Theme — global.js ============ */
(function(){
  'use strict';

  /* ---- Announcement bar rotation ---- */
  function initAnnouncement(){
    var slides = document.querySelectorAll('.announcement__slide');
    if(slides.length < 2) return;
    var i = 0;
    setInterval(function(){
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, 4000);
  }

  /* ---- Mobile nav ---- */
  function initMobileNav(){
    var burger = document.querySelector('[data-burger]');
    var nav = document.querySelector('.mobile-nav');
    var overlay = document.querySelector('.mobile-nav__overlay');
    if(!burger || !nav) return;
    function open(){nav.classList.add('is-open');overlay.classList.add('is-open');document.body.style.overflow='hidden';}
    function close(){nav.classList.remove('is-open');overlay.classList.remove('is-open');document.body.style.overflow='';}
    burger.addEventListener('click', open);
    overlay.addEventListener('click', close);
    var closeBtn = nav.querySelector('[data-mobile-close]');
    if(closeBtn) closeBtn.addEventListener('click', close);
  }

  /* ---- Cart drawer ---- */
  function initCartDrawer(){
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-drawer-overlay]');
    if(!drawer) return;
    function open(){drawer.classList.add('is-open');overlay.classList.add('is-open');document.body.style.overflow='hidden';}
    function close(){drawer.classList.remove('is-open');overlay.classList.remove('is-open');document.body.style.overflow='';}

    document.querySelectorAll('[data-cart-toggle]').forEach(function(el){
      el.addEventListener('click', function(e){
        e.preventDefault();
        refreshCart().then(open);
      });
    });
    if(overlay) overlay.addEventListener('click', close);
    var closeBtn = drawer.querySelector('[data-drawer-close]');
    if(closeBtn) closeBtn.addEventListener('click', close);
    window.__openCartDrawer = function(){ refreshCart().then(open); };
  }

  /* ---- AJAX add to cart ---- */
  function initAddToCart(){
    document.querySelectorAll('[data-product-form]').forEach(function(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var btn = form.querySelector('[type=submit]');
        var original = btn ? btn.textContent : '';
        if(btn){btn.textContent = 'Adding…';btn.disabled = true;}
        fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify(serialize(form))
        })
        .then(function(r){return r.json();})
        .then(function(){
          if(btn){btn.textContent = original;btn.disabled = false;}
          if(window.__openCartDrawer) window.__openCartDrawer();
        })
        .catch(function(){
          if(btn){btn.textContent = original;btn.disabled = false;}
          form.submit();
        });
      });
    });
  }

  function serialize(form){
    var obj = {};
    var fd = new FormData(form);
    fd.forEach(function(v,k){
      if(k === 'id') obj.id = v;
      else if(k === 'quantity') obj.quantity = parseInt(v,10) || 1;
      else { obj.properties = obj.properties || {}; }
    });
    if(!obj.quantity) obj.quantity = 1;
    return obj;
  }

  /* ---- Refresh cart drawer contents ---- */
  function refreshCart(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){ renderCart(cart); return cart; })
      .catch(function(){});
  }

  function formatMoney(cents){
    return '$' + (cents/100).toLocaleString('es-MX', {minimumFractionDigits:2, maximumFractionDigits:2});
  }

  function renderCart(cart){
    var body = document.querySelector('[data-cart-items]');
    var count = document.querySelectorAll('[data-cart-count]');
    var total = document.querySelector('[data-cart-total]');
    if(count.length){
      count.forEach(function(c){ c.textContent = cart.item_count; c.style.display = cart.item_count ? '' : 'none'; });
    }
    if(total) total.textContent = formatMoney(cart.total_price);
    if(!body) return;
    if(cart.item_count === 0){
      body.innerHTML = '<div class="empty-state"><p class="text-soft">Tu carrito está vacío</p><a href="/collections/all" class="btn btn--outline" style="margin-top:16px">Seguir comprando</a></div>';
      return;
    }
    var html = '';
    cart.items.forEach(function(item){
      html += '<div class="cart-row">'
        + '<a href="'+item.url+'"><img src="'+(item.image ? item.image.replace(/(\.[^.]+)$/, '_160x$1') : '')+'" alt=""></a>'
        + '<div><p class="card__title" style="margin-bottom:4px"><a href="'+item.url+'">'+item.product_title+'</a></p>'
        + (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="text-soft" style="font-size:1.3rem">'+item.variant_title+'</p>' : '')
        + '<p class="text-soft" style="font-size:1.3rem">Cant.: '+item.quantity+'</p></div>'
        + '<div style="text-align:right">'+formatMoney(item.final_line_price)+'</div>'
        + '</div>';
    });
    body.innerHTML = html;
  }

  document.addEventListener('DOMContentLoaded', function(){
    initAnnouncement();
    initMobileNav();
    initCartDrawer();
    initAddToCart();
    refreshCart();
  });
})();
